import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { GAMES } from "./games";

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.05, ease: [0.2, 0.8, 0.2, 1] },
  }),
};

export default function GamesGrid() {
  return (
    <section id="games" data-testid="games-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="min-w-0">
            <span className="label-tag">// ARSENAL</span>
            <h2 className="font-display font-black uppercase text-4xl md:text-6xl tracking-tighter mt-3">
              THE <span className="neon-text-magenta">ARSENAL</span>
            </h2>
            <p className="mt-4 text-zinc-400 max-w-xl">
              The full NFG Games suite from live TikTok — crash, word chains, quizzes, arena modes,
              and more. Chat is the controller.
            </p>
          </div>
          <span className="font-mono text-xs text-zinc-500 shrink-0">
            // {String(GAMES.length).padStart(2, "0")} NODES ONLINE
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 md:gap-6">
          {GAMES.map((g, i) => (
            <motion.div
              key={g.id}
              custom={i}
              variants={cardVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.12 }}
              data-testid={`game-card-${g.id}`}
              className="tilt-card relative group rounded-2xl overflow-hidden border border-white/10 bg-black min-h-[280px]"
              style={{ boxShadow: `0 0 0 1px rgba(255,255,255,0.04)` }}
            >
              <div className="absolute inset-0">
                <img
                  src={g.image}
                  alt=""
                  className="h-full w-full object-cover scale-105 group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(5,5,10,0.15) 0%, rgba(5,5,10,0.35) 42%, rgba(5,5,10,0.94) 100%)",
                }}
              />
              <div className="pointer-events-none absolute inset-0">
                <span className="absolute top-3 left-3 h-3 w-3 border-l border-t" style={{ borderColor: g.accent }} />
                <span className="absolute top-3 right-3 h-3 w-3 border-r border-t" style={{ borderColor: g.accent }} />
                <span className="absolute bottom-3 left-3 h-3 w-3 border-l border-b" style={{ borderColor: g.accent }} />
                <span className="absolute bottom-3 right-3 h-3 w-3 border-r border-b" style={{ borderColor: g.accent }} />
              </div>

              <div className="absolute top-4 left-4 right-4 flex justify-between items-start z-10 gap-2">
                <span
                  className="font-mono text-[0.58rem] uppercase tracking-[0.24em] px-2 py-1 rounded-full border bg-black/45"
                  style={{ borderColor: `${g.accent}66`, color: g.accent }}
                >
                  // {g.tag}
                </span>
                {g.stats?.live && (
                  <span className="font-mono text-[0.58rem] uppercase tracking-[0.24em] text-amber-300 flex items-center gap-1 shrink-0">
                    <span className="h-1.5 w-1.5 rounded-full bg-amber-400 animate-pulse" />
                    LIVE
                  </span>
                )}
              </div>

              <Link to={`/games/${g.slug}`} className="absolute inset-0 z-20" aria-label={`Open ${g.name}`} />

              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 z-10 pointer-events-none">
                <h3 className="font-display font-black uppercase text-2xl md:text-3xl text-white tracking-tight leading-none pr-8">
                  {g.name.split(" ").map((w, idx) => (
                    <span
                      key={`${g.id}-${idx}`}
                      style={idx === 1 ? { color: g.accent, textShadow: `0 0 18px ${g.accent}88` } : {}}
                    >
                      {w}
                      {idx === 0 ? " " : ""}
                    </span>
                  ))}
                </h3>
                <p className="mt-2 text-sm text-zinc-300/90 max-w-sm line-clamp-2">{g.tagline}</p>
                <div className="mt-4 flex items-center justify-between gap-3">
                  <span className="font-mono text-xs text-zinc-500">→ VIEW GAME DETAILS</span>
                  <span
                    className="inline-flex items-center justify-center h-9 w-9 rounded-full border transition-all group-hover:translate-x-1 shrink-0"
                    style={{ borderColor: `${g.accent}88`, color: g.accent }}
                  >
                    ↗
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
